var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBurgerMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 17,
    viewBox: "0 0 28 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.9996 1.16092C27.9996 1.7132 27.5518 2.16092 26.9996 2.16092H1.32812C0.77584 2.16092 0.328125 1.7132 0.328125 1.16092C0.328125 0.608634 0.77584 0.160919 1.32812 0.160919H26.9996C27.5518 0.160919 27.9996 0.608634 27.9996 1.16092Z",
    fill: "#081B4D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.9996 8.16092C27.9996 8.7132 27.5518 9.16092 26.9996 9.16092H1.32812C0.77584 9.16092 0.328125 8.7132 0.328125 8.16092C0.328125 7.60863 0.77584 7.16092 1.32812 7.16092H26.9996C27.5518 7.16092 27.9996 7.60863 27.9996 8.16092Z",
    fill: "#081B4D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.9996 15.1609C27.9996 15.7132 27.5518 16.1609 26.9996 16.1609H1.32812C0.77584 16.1609 0.328125 15.7132 0.328125 15.1609C0.328125 14.6086 0.77584 14.1609 1.32812 14.1609H26.9996C27.5518 14.1609 27.9996 14.6086 27.9996 15.1609Z",
    fill: "#081B4D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBurgerMenu);
export default __webpack_public_path__ + "static/media/burgerMenu.35d981e2bf61b475d08ea557eed3b9a0.svg";
export { ForwardRef as ReactComponent };